export default {
    smartSearch: {
        syntaxHelper: 'Search Helper >',
        sections: {
            ANCS: 'Standardized Current Assignee',
            AUTOCOMPLETE: 'Keyword Suggestion',
            FIELD: 'Fields',
            HISTORY: 'History',
            KEYWORDS: 'Keywords',
            LOGIC: 'Logic',
            keywordFields: 'Keywords Fields',
            assigneeFields: 'Assignee Fields',
            classificationNumberFields: 'Classification Number Fields',
            otherFields: 'Other Fields',
            SAMPLE: 'Sample',
            CASE_NATURE: 'Case Property',
            TRIAL_GRADE: 'Trial Level',
            PLE_TYPE: 'Pledge Type',
            PATENT_TYPE: 'Patent Type',
            AUTHORITY: 'Authority',
            ANS_TYPE: 'Std. Original Assignee Type',
            CASE_REGION: 'Case Region',
            EXCLUSIVITY: 'Exclusivity',
            SIMPLE_LEGAL_STATUS: 'Simple Legal Status',
            LEGAL_STATUS: 'Legal Status',
            LEGAL_EVENT: 'Legal Events',
            CITE_CATEGORY: 'Citation/Rejection Category',
            OUTCOME_STATUS: 'Litigation Status',
            ANCS_TYPE: 'Std. Current Assignee Type',
            GOV: 'Government Interest',
            LICENSE: 'Licensing',
            LITIGATION: 'Litigation',
            PLEDGE: 'PLEDGE',
            REEXAMINVALID: 'REEXAMINVALID',
            SEP_SOURCE: 'SEP Source',
            GNAME: 'Grouped Assignee',
            EPDS_LS: 'EP Designated State Legal Status',
            EPDS_SLS: 'EP Designated State Simple Legal Status',
            ATC_VALUE: 'Agent involvement',
            UP_STATUS: 'Status of Unified Patent Court',
            EFAM_STATUS: 'Patsnap Family Status',
        },
        keywordQueryTitle: 'Add all the recommended keywords below to your query',
    },
};
